import chroma from 'chroma-js';
import { Coloring, ColoringBands } from '../api/api.ts';

export const getBandColor = (
  value: number,
  bands: ColoringBands['bands']
): string => {
  const index = bands.findIndex(
    (band) => 'startingAt' in band && band.startingAt > value
  );
  return bands[index !== -1 ? index - 1 : bands.length - 1].color;
};

export class ColorScaler {
  min: number;
  max: number;
  lookupRed: Uint8Array;
  lookupGreen: Uint8Array;
  lookupBlue: Uint8Array;

  constructor(colors: string[], min: number, max: number) {
    this.min = min;
    this.max = max;

    const scale = chroma
      .scale(colors)
      .domain([0, 1])
      .mode('lrgb')
      .correctLightness();

    const lookupRed = new Uint8Array(255);
    const lookupGreen = new Uint8Array(255);
    const lookupBlue = new Uint8Array(255);
    // create lookup tables
    new Array(255).fill(null).forEach((_, index) => {
      const color = scale(index / 255);
      lookupRed[index] = color.get('rgb.r');
      lookupGreen[index] = color.get('rgb.g');
      lookupBlue[index] = color.get('rgb.b');
    });

    this.lookupRed = lookupRed;
    this.lookupGreen = lookupGreen;
    this.lookupBlue = lookupBlue;
  }

  colorize(value: number): [number, number, number] {
    const value255 = Math.round(
      ((value - this.min) / (this.max - this.min)) * 255
    );
    return [
      this.lookupRed[value255],
      this.lookupGreen[value255],
      this.lookupBlue[value255],
    ];
  }
}

export class ColorBandColorizer {
  lookupRed: Uint8Array;
  lookupGreen: Uint8Array;
  lookupBlue: Uint8Array;

  constructor(colorBands: ColoringBands['bands']) {
    const lookupRed = new Uint8Array(255);
    const lookupGreen = new Uint8Array(255);
    const lookupBlue = new Uint8Array(255);
    // create lookup tables
    new Array(255).fill(null).forEach((_, index) => {
      const chromaColor = chroma(getBandColor(index, colorBands));
      lookupRed[index] = chromaColor.get('rgb.r');
      lookupGreen[index] = chromaColor.get('rgb.g');
      lookupBlue[index] = chromaColor.get('rgb.b');
    });

    this.lookupRed = lookupRed;
    this.lookupGreen = lookupGreen;
    this.lookupBlue = lookupBlue;
  }

  colorize(value: number): [number, number, number] {
    return [
      this.lookupRed[value],
      this.lookupGreen[value],
      this.lookupBlue[value],
    ];
  }
}
